module.exports = __webpack_public_path__ + "static/media/blue-loader.808f181d.svg";